<template>
  <div>
    <g-breadcrumb :paginas="paginaStatus.caminhoMigalha" />

    <form @submit.prevent="salvar">
      <g-gridview
        id="refDocumentos"
        name="refDocumentos"
        ref="refDocumentos"
        :exibirEtiqueta="false"
        :colunas="colunasGridDocumentos"
        :inserirElemento="getElemento"
        :getElemento="getElemento"
        :editarElemento="editarElemento"
        :executarValidacao="validarDocumento"
        :limparCampos="limparDocumento"
        :exibirBotaoVisualizacao="visualizacao"
        :exibirBotaoEdicao="edicao"
        :exibirBotaoExclusao="exclusao"
        :confExcluir="confExcluirDocumento"
        :inicializarVazio="true"
      >
        <div class="row">
          <div class="col-sm-6 col-xs-6">
            <g-input
              id="refCodigo"
              name="refCodigo"
              ref="refCodigo"
              tipo="text"
              etiqueta="Código"
              validacao="numeric"
              :desabilitar="true"
              :foco="false"
              v-model="documentoNecessarioSelecionado.codDocumentacaoNecessaria"
            >
            </g-input>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-xs-12">
            <g-autocomplete
              id="refTipoProcesso"
              name="refTipoProcesso"
              ref="refTipoProcesso"
              etiqueta="Tipo de Processo"
              descricaoPrimaria="desTipoProcesso"
              valor="codTipoProcesso"
              :foco="false"
              :api=apiTipoProcesso
              :desabilitar="desabilitarcampos"
              v-model="codTipoProcesso"
            >
            </g-autocomplete>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-xs-12">
            <g-autocomplete
              id="refAssunto"
              name="refAssunto"
              ref="refAssunto"
              etiqueta="Assunto"
              valor="codAssunto"
              descricaoPrimaria="desAssunto"
              :foco="false"
              :api=apiAssunto
              :desabilitar="desabilitarAssunto"
              v-model="codAssunto"
            >
            </g-autocomplete>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-xs-12">
            <g-autocomplete
              id="refSubAssunto"
              name="refSubAssunto"
              ref="refSubAssunto"
              etiqueta="Subassunto"
              valor="codSubassunto"
              descricaoPrimaria="desSubassunto"
              :api=apiSubAssunto
              :foco="false"
              :desabilitar="desabilitarSubAssunto"
              :filtroAdicional="filtroPesquisaSubAssunto"
              v-model="codSubassunto"
            >
            </g-autocomplete>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-xs-12">
            <g-autocomplete
              id="refDocumento"
              name="refDocumento"
              ref="refDocumento"
              etiqueta="Documento"
              valor="codDocumento"
              descricaoPrimaria="nomDocumento"
              :api=apiDocumento
              :foco="false"
              :desabilitar="desabilitarDocumento"
              v-model="codDocumento"
            >
            </g-autocomplete>
          </div>
        </div>
        &ensp;
        <div class="row">

          <div class="col-xs-5 col-md-5">
            <g-option
              id="ativo"
              name="ativo"
              ref="refAtivo"
              tipo="radio"
              :option="arrayAtivoEnum"
              :desabilitar="paginaStatus.desabilitarEdicao"
              etiqueta="Ativo"
              validacao="required"
              v-model="indAtivo"
            ></g-option>
          </div>
        </div>

      </g-gridview>
    </form>
    <div class="col-12 text-right pad-20t-h10-80b">
      <q-btn
        round
        id="salvar"
        name="salvar"
        class="fixed"
        color="positive"
        icon="check"
        size="lg"
        @click="salvar"
        style="right: 18px; bottom:18px"
        v-show="!paginaStatus.desabilitarEdicao"
      >
        <q-tooltip>Salvar</q-tooltip>
      </q-btn>
    </div>
  </div>
</template>
<script>
import api from 'components/util/api'
import msg from 'components/util/msg'
import util from 'components/util/util'
import utilHttp from 'components/util/utilHttp'
import GInput from 'components/util/gInput'
import GSelect from 'components/util/gSelect'
import GOption from 'components/util/gOption'
import constante from 'components/util/constante'
import GGridview from 'components/util/gGridview'
import GDatepicker from 'components/util/gDatepicker'
import GBreadcrumb from 'components/util/gBreadcrumb'
import GAutocomplete from 'components/util/gAutocomplete'

export default {
  data () {
    return {
      chaveLocalStorage: 'documentacaoNecessaria',
      // api usadas
      apiDocumento: api.DOCUMENTO,
      apiTipoProcesso: api.TIPO_DE_PROCESSO_DESCRICAO,
      apiAssunto: api.ASSUNTO,
      apiSubAssunto: api.SUB_ASSUNTO_COD_ASSUNTO,
      apiBuscarPorTipoAssuntoSubAssunto: api.DOCUMENTACAO_NECESSARIA_TIPO_PROCESSO_E_ASSUNTO_SUBASSUNTO,
      desabilitarPorTipoProcesso: '',
      desabilitarSubAssunto: '',
      codAssunto: '',
      documentacaoNecessarioInicio: false,
      documentacaoNecessarioInicioGrid: false,
      subAssuntoInicio: false,
      desabilitarDocumento: false,
      desabilitarcampos: false,
      desabilitarAssunto: false,
      arrayAtivoEnum: constante.ATIVO_ENUM,
      indAtivo: 'S',
      codDocumento: '',
      codTipoProcesso: '',
      codSubassunto: '',
      documentoSelecionado: '',
      visualizacao: '',
      edicao: '',
      exclusao: '',
      docAux: {},
      documentoNecessariaExcluirList: [],
      documentoNecessarioSelecionado: {
        documento: {},
        tipoProcesso: {},
        subassunto: {
          assunto: {}
        }
      },
      documentacaoNecessariaArrayBkp: [],
      confExcluirDocumento: {
        clique: (item) => this.confExcluirDocumentoFuncao(item)
      },
      paginaStatus: {
        documentacaoNecessaria: {
          documento: {},
          tipoProcesso: {},
          subassunto: {
            assunto: {}
          }
        }
      },

      documentacaoNecessariaAux: {
        documento: {},
        tipoProcesso: {},
        subassunto: {
          assunto: {}
        }
      },
      colunasGridDocumentos: [
        {
          conteudoTipo: '',
          largura: '80%',
          cabecalhoEtiqueta: 'Documentos Selecionados',
          cabecalhoClasse: 'text-left',
          conteudoClasse: 'text-left',
          propriedade: 'documento.nomDocumento',
          chave: 'documento.nomDocumento'
          // requerido: true
        },
        {
          conteudoTipo: 'badge',
          propriedade: 'indAtivo',
          cabecalhoEtiqueta: 'Ativo',
          cabecalhoClasse: 'text-center',
          conteudoClasse: 'text-center',
          largura: '10%',
          formatar: (valor) => util.getSimNao(valor)
        }
      ]
    }
  },
  methods: {
    salvar () {
      var self = this
      var tamanho = self.$refs['refDocumentos'].dadosLength()
      var documentoNecessariaSalvarList = this.$refs['refDocumentos'].getDados()

      if (util.validarComponentes(self.$refs)) {
        if (tamanho !== 0) {
          if (documentoNecessariaSalvarList.length > 0 || self.documentoNecessariaExcluirList.length > 0 || self.paginaStatus.operacao.descricao !== 'Novo') {
            var documentacaoNecessariaVisao = {
              documentoNecessariaSalvarList: [],
              documentoNecessariaExcluirList: []
            }
            documentacaoNecessariaVisao.documentoNecessariaSalvarList = documentoNecessariaSalvarList
            documentacaoNecessariaVisao.documentoNecessariaExcluirList = this.documentoNecessariaExcluirList
            utilHttp.httpPostCarregando(api.DOCUMENTACAO_NECESSARIA, documentacaoNecessariaVisao, resposta => {
              if (this.documentacaoNecessariaArrayBkp.length === 0) {
                util.exibirToastSucesso(msg.m(2))
              } else {
                util.exibirToastSucesso(msg.m(3))
              }
            })
          } else {
            util.exibirToastSucesso(msg.m(14))
          }
          util.retornarCaminhoMigalhaPaginaAnterior(this)
        } else {
          util.exibirToastAviso('No mínimo 1 (um) registro deve ser adicionado.')
        }
      }
    },
    getElemento () {
      var self = this
      if (self.documentoSelecionado.codDocumentacaoNecessaria) {
        if (self.$refs['refDocumento'].objetoSelecionado.codDocumento) self.documentoNecessarioSelecionado.documento = self.$refs['refDocumento'].objetoSelecionado
      } else {
        self.documentoNecessarioSelecionado = JSON.parse(JSON.stringify(self.documentoNecessarioSelecionado))
        if (self.$refs['refDocumento'].objetoSelecionado.codDocumento) self.documentoNecessarioSelecionado.documento = self.$refs['refDocumento'].objetoSelecionado
        self.documentoNecessarioSelecionado.tipoProcesso.codTipoProcesso = self.codTipoProcesso
        self.documentoNecessarioSelecionado.subassunto.codSubassunto = self.codSubassunto
        self.documentoNecessarioSelecionado.subassunto.assunto.codAssunto = self.codAssunto
        self.documentoNecessarioSelecionado.indAtivo = self.indAtivo
        self.documentoNecessarioSelecionado.codUsuario = this.$login.getCodUsuario()
      }
      if (self.codDocumento === '') self.documentoNecessarioSelecionado.documento = {}

      // Verificar se o elemento selecionado existe na lista de exclusão, se existir, o retira
      var doc = self.documentoNecessariaExcluirList.filter(d => d.documento.codDocumento === self.documentoNecessarioSelecionado.documento.codDocumento)
      if (doc !== undefined && doc != null && doc.length > 0) {
        self.documentoNecessariaExcluirList.splice(doc, 1)
      }

      return this.documentoNecessarioSelecionado
    },
    validarDocumento () {
      var self = this
      if (self.codAssunto &&
        self.codTipoProcesso && self.codSubassunto &&
        self.codDocumento) {
        return true
      } else {
        if (self.codTipoProcesso === '') {
          util.exibirToastAviso(msg.m(11, 'Tipo de processo'))
        } else if (self.codAssunto === '') {
          util.exibirToastAviso(msg.m(11, 'Assunto'))
        } else if (self.codSubassunto === '') {
          util.exibirToastAviso(msg.m(11, 'Subassunto'))
        } else if (self.codDocumento === '') {
          util.exibirToastAviso(msg.m(11, 'Documento'))
        }
        return false
      }
    },
    camposPreenchidos () {
      var self = this
      if (self.codTipoProcesso !== '' && self.codTipoProcesso !== undefined &
        self.codSubassunto !== '' && self.codSubassunto !== undefined &&
        self.codAssunto !== '' && self.codAssunto !== undefined) {
        return true
      } else {
        return false
      }
    },
    /*
    verifica se os campos tipo processo, subassunto sao diferente do grid se for o grid vai ser limpado
    */

    verificaCampos () {
      var self = this
      // verifica se todos os campos estao preenchidos
      if (self.codTipoProcesso !== '' && self.codTipoProcesso !== undefined &
        self.codSubassunto !== '' && self.codSubassunto !== undefined &&
        self.codAssunto !== '' && self.codAssunto !== undefined) {
        // se todos campos forem preenchidos ele comeca a verificar  se os campos sao os mesmo que o grid
        var documentoNecessariaList = this.$refs['refDocumentos'].getDados()
        var diferente = true

        // se existe valores no grid
        if (documentoNecessariaList.length > 0) {
          // verifica se os valores dos campos sao diferente do grid
          if (self.codTipoProcesso === documentoNecessariaList[0].tipoProcesso.codTipoProcesso &&
            self.codSubassunto === documentoNecessariaList[0].subassunto.codSubassunto &&
            self.codAssunto === documentoNecessariaList[0].subassunto.assunto.codAssunto) {
            diferente = false
          }
        }
        // se for diferente o grid sera limpo
        if (diferente) {
          this.limparDocumento()
          this.resetarGrid()
          this.carregaGrid()
        }
      }
    },
    // limpa todas as variaveis relacionadas ao Grid
    resetarGrid () {
      var self = this
      this.$refs['refDocumentos'].limparDados()
      self.$refs['refDocumentos'].indexEdicao = ''
      self.documentosArrayBkp = []
      self.documentoNecessariaExcluirList = []
      self.documentoNecessarioSelecionado = JSON.parse(JSON.stringify(self.documentoNecessarioSelecionado))
      self.documentoNecessarioSelecionado.tipoProcesso = this.$refs['refTipoProcesso'].objetoSelecionado
      self.documentoNecessarioSelecionado.subassunto = this.$refs['refSubAssunto'].objetoSelecionado
      self.documentoNecessarioSelecionado.subassunto.assunto = this.$refs['refAssunto'].objetoSelecionado
      self.paginaStatus.documentacaoNecessaria = self.documentoNecessarioSelecionado
      self.paginaStatus.documentacaoNecessaria.codDocumentacaoNecessaria = ''
    },
    editarElemento (item) {
      var self = this
      // correcao do icone de editar sumir quando carrega outro grid
      if (this.paginaStatus.operacao.descricao === 'Visualizar Documentação Necessária') {
        self.$refs['refDocumentos'].indexEdicao = ''
      }

      self.documentoNecessarioSelecionado = item
      self.indAtivo = self.documentoNecessarioSelecionado.indAtivo
      //  this.$refs['refCodigo'].carregar(self.documentacaoNecessariaAux.codDocumentacaoNecessaria, self.documentacaoNecessariaAux.codDocumentacaoNecessaria)
      this.$refs['refTipoProcesso'].carregar(self.documentoNecessarioSelecionado.tipoProcesso.codTipoProcesso, self.documentoNecessarioSelecionado.tipoProcesso.desTipoProcesso)
      this.$refs['refAssunto'].carregar(self.documentoNecessarioSelecionado.subassunto.assunto.codAssunto, self.documentoNecessarioSelecionado.subassunto.assunto.desAssunto)
      this.$refs['refSubAssunto'].carregar(self.documentoNecessarioSelecionado.subassunto.codSubassunto, self.documentoNecessarioSelecionado.subassunto.desSubassunto)
      this.$refs['refDocumento'].carregar(self.documentoNecessarioSelecionado.documento.codDocumento, self.documentoNecessarioSelecionado.documento.nomDocumento)
    },
    filtroPesquisaSubAssunto () {
      return '/'.concat(this.codAssunto)
    },
    limparDocumento () {
      if (this.paginaStatus.operacao.descricao !== 'Visualizar Documentação Necessária') {
        this.documentoNecessarioSelecionado.codDocumentacaoNecessaria = ''
        this.codDocumento = ''
        this.$refs['refDocumento'].limpar()
      }
      /* else {
        // limpar todos os campos na hora do visualizar
        this.codTipoProcesso = ''
        this.codSubassunto = ''
        this.codAssunto = ''
        this.codDocumento = ''
        this.documentoNecessarioSelecionado.codDocumentacaoNecessaria = ''
        this.$refs['refDocumento'].limpar()
        this.$refs['refTipoProcesso'].limpar()
      }
      */
    },
    chanceAssunto () {
      // limpar o campo quando muda de assunto
      if (this.codAssunto !== this.documentoNecessarioSelecionado.subassunto.assunto.codAssunto) {
        this.documentoNecessarioSelecionado.subassunto.assunto.codAssunto = ''
        this.codSubassunto = ''
        this.$refs['refSubAssunto'].limpar()
      }
    },
    confExcluirDocumentoFuncao (item) {
      var self = this
      util.exibirConfirmacaoExclusao('EXCLUSÃO', msg.m(5), () => {
        this.$refs['refDocumentos'].removerElementoAposConfirmacaoExclusao(item)
        // adiciona na lista de excluir
        self.documentoNecessariaExcluirList.push(item)
      })
    },
    carregaGrid () {
      // carrega um grid de acordo tipo processo e subassunto
      var self = this
      self.paginaStatus.documentacaoNecessaria.codUsuario = self.$login.getCodUsuario()
      if (self.paginaStatus.documentacaoNecessaria.tipoProcesso.codTipoProcesso && self.paginaStatus.documentacaoNecessaria.subassunto.codSubassunto) {
        var filtro = ''
          .concat('?codTipoProcesso=').concat(self.paginaStatus.documentacaoNecessaria.tipoProcesso.codTipoProcesso)
          .concat('&codSubassunto=').concat(self.paginaStatus.documentacaoNecessaria.subassunto.codSubassunto)
        utilHttp.httpGet(api.DOCUMENTACAO_NECESSARIA_TIPO_PROCESSO_E_SUB_ASSUNTO.concat(filtro), resposta => {
          var documentacaoNecessariaLista = resposta.body
          self.documentacaoNecessariaArrayBkp = JSON.parse(JSON.stringify(documentacaoNecessariaLista))
          // usado para comparar
          this.$refs['refDocumentos'].inicializar(documentacaoNecessariaLista)
          // if (self.paginaStatus.operacao.descricao !== 'Novo' && documentacaoNecessariaLista.length !== 0) {
          /*
            SISTEMA PARA CARREGAR O ELEMENTO DO GRID NA LINHA CORRETA
          */
          // if (self.docAux.documento) {
          //   self.$refs['refDocumento'].carregar(self.docAux.documento.codDocumento, self.docAux.documento.nomDocumento)
          //   self.codDocumento = self.docAux.documento.codDocumento
          // }
          // atualiza

          // var listaRes = self.$refs['refDocumentos'].getDados() // .indexEdicao = '0'
          // var count = 0, codRes = self.docAux.documento.codDocumento

          // // achar indice de edicao
          // for (let index = 0; index < listaRes.length; index++) {
          //   if (codRes === listaRes[index].documento.codDocumento) {
          //     break
          //   }
          //   count++
          // }

          // if (this.paginaStatus.operacao.descricao === 'Editar Documentação Necessária') {
          //   self.$refs['refDocumentos'].indexEdicao = count // COLOCA A LINHA DE EDICAO
          // }

          // self.documentoNecessarioSelecionado.codDocumentacaoNecessaria = self.docAux.codDocumentacaoNecessaria
          // self.documentoNecessarioSelecionado.tipoProcesso = self.docAux.tipoProcesso
          // self.documentoNecessarioSelecionado.subassunto = self.docAux.subassunto
          // self.documentoNecessarioSelecionado.subassunto.assunto = self.docAux.subassunto.assunto
          // self.documentoNecessarioSelecionado.documento = self.docAux.documento
          // }
        })
      }
    },
    carregarAutocompletes () {
      var self = this
      self.docAux = self.paginaStatus.documentacaoNecessaria
      // self.indAtivo = self.paginaStatus.documentacao
      setTimeout(() => {
        // TIPO DE PROCESSO
        self.$refs['refTipoProcesso'].carregar(self.paginaStatus.documentacaoNecessaria.tipoProcesso.codTipoProcesso, self.paginaStatus.documentacaoNecessaria.tipoProcesso.desTipoProcesso)
      }, 100)

      setTimeout(() => {
        // ASSUNTO
        self.$refs['refAssunto'].carregar(self.paginaStatus.documentacaoNecessaria.subassunto.assunto.codAssunto, self.paginaStatus.documentacaoNecessaria.subassunto.assunto.desAssunto)
      }, 100)

      setTimeout(() => {
        // SUB-ASSUNTO
        self.$refs['refSubAssunto'].carregar(self.paginaStatus.documentacaoNecessaria.subassunto.codSubassunto, self.paginaStatus.documentacaoNecessaria.subassunto.desSubassunto)
      }, 100)
    }
  },
  watch: {
    paginaStatus: {
      handler (valor) {
        if (valor) {
          util.adicionarNoStorage(this.chaveLocalStorage, valor)
        } else util.removerDoStorage(this.chaveLocalStorage)
      }
    },
    codTipoProcesso: {

      handler (valor) {
        if (this.codTipoProcesso === '' || this.codTipoProcesso === undefined) {
          this.$refs['refAssunto'].limpar()
          this.desabilitarAssunto = true
        } else {
          if (this.paginaStatus.operacao.descricao === 'Novo') {
            this.desabilitarAssunto = false
          }
        }

        this.verificaCampos()
      }
    },
    codAssunto: {
      handler (valor) {
        var self = this

        if (self.codAssunto === '' ||
          self.codAssunto === undefined) {
          this.$refs['refSubAssunto'].limpar()
          this.desabilitarSubAssunto = true
        } else {
          if (this.paginaStatus.operacao.descricao === 'Novo') {
            this.chanceAssunto()
            this.desabilitarSubAssunto = false
          }
        }
      }
    },
    codSubassunto: {
      handler (valor) {
        this.verificaCampos()
      }
    }
  },
  mounted () {
    if (this.$route.params.paginaStatus) {
      this.paginaStatus = this.$route.params.paginaStatus
      this.paginaStatus.caminhoMigalha.push({
        icone: this.paginaStatus.operacao.icone,
        descricao: this.paginaStatus.operacao.descricao,
        rotaNome: 'documentacaoNecessaria'
      })
    } else if (util.recuperarDoStorage(this.chaveLocalStorage)) {
      this.paginaStatus = util.recuperarDoStorage(this.chaveLocalStorage)
    }
    if (this.paginaStatus.operacao.descricao !== 'Novo') {
      this.carregaGrid()
      this.desabilitarcampos = true
      this.desabilitarSubAssunto = true
      this.desabilitarAssunto = true
      this.carregarAutocompletes()
    }
    if (this.paginaStatus.operacao.descricao === 'Visualizar Documentação Necessária') {
      this.visualizacao = false
      this.exclusao = false
      this.edicao = false
      this.desabilitarSubAssunto = true
      this.desabilitarAssunto = true
      this.desabilitarDocumento = true
      this.desabilitarcampos = true
    } else {
      this.visualizacao = false
      this.exclusao = true
      this.edicao = true
    }
  },
  components: { GBreadcrumb, GInput, GSelect, GOption, GAutocomplete, GGridview, GDatepicker }
}
</script>
